jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.leisure-slider').length ) {
        let $ = jQuery;
        $(".leisure-slides").slick({
            rows: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 7500,
            arrows: false,
            dots: true,
            fade: true
        });
    }
});